import styled from 'styled-components';

const TitleHeader = styled.h1`
  flex: 1;
`;

export default TitleHeader;
